import { Box, css } from '@mui/material'

import { useMQ } from '../hooks/useMQ'
import { HumaFullLogoWhite } from './icons'
import { LaunchApp } from './LaunchApp'

export function Header() {
  const { isBelowXsSize, isSmSize } = useMQ()

  const styles = {
    appBar: css`
      z-index: 1;
      position: relative;
      background-color: unset;
      box-shadow: unset;
      padding: ${isSmSize ? '16px 16px 0 16px' : '16px 32px 0 48px'};
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
    `,
    humaLogo: css`
      height: 36px;
      width: auto;
      margin-bottom: -10px;
    `,
    headerButton: css`
      padding: ${isBelowXsSize ? '6px 18px' : '12px 40px'};
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
      font-weight: 700;
      letter-spacing: 0.46px;
      font-size: 15px;
      height: ${isSmSize ? '42px' : '48px'};
    `,
  }

  return (
    <Box css={styles.appBar}>
      <a href='/'>
        <HumaFullLogoWhite css={styles.humaLogo} />
      </a>
      <LaunchApp />
    </Box>
  )
}
